import { render, staticRenderFns } from "./homeMenuItem.vue?vue&type=template&id=5fa7a71b&"
import script from "./homeMenuItem.vue?vue&type=script&lang=js&"
export * from "./homeMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/template1/menu/homeMenuItem.vue"
export default component.exports